export const createVenue = ({
  address1 = '',
  ksk_info = undefined,
  email = '',
  feature = '',
  postalcode = '',
  clientID = undefined,
  type = '',
  booking_location_name = '',
  country = '',
  age_limit = '',
  fax = '',
  url2 = '',
  venue_capacity = '',
  latitude = '',
  booking_location_id = '',
  created = '',
  sponsoring_info = undefined,
  market_area = '',
  longitude = '',
  url1 = '',
  keywords = '',
  google_place_id = '',
  mechanical_info = undefined,
  opening_time = '',
  dist_to_airport = undefined,
  last_modified = '',
  merchandise_info = undefined,
  city = '',
  phone1 = '',
  phone2 = '',
  original_id = undefined,
  curfew = '',
  address2 = ''
}) => {
  return {
    address1,
    ksk_info,
    email,
    feature,
    postalcode,
    clientID,
    type,
    booking_location_name,
    country,
    age_limit,
    fax,
    url2,
    venue_capacity,
    latitude,
    booking_location_id,
    created,
    sponsoring_info,
    market_area,
    longitude,
    url1,
    keywords,
    google_place_id,
    mechanical_info,
    opening_time,
    dist_to_airport,
    last_modified,
    merchandise_info,
    city,
    phone1,
    phone2,
    original_id,
    curfew,
    address2
  }
};
const NEW_VENUE_ID = 'NEW_VENUE';

const createNewVenue = (args = createVenue()) => createVenue({ booking_location_id: NEW_VENUE_ID, ...args });
const isNewVenue = (venue = createVenue()) => venue.booking_location_id == NEW_VENUE_ID;

const getVenueInfo = (venue) => {
  return `
${venue.booking_location_name ? `<a 
class="ut-link ut-text-sm ut-text-accent5"
href="#/main/booking/venues/${venue.booking_location_id}/overview">${venue.booking_location_name}</a><br>` : ''}
${venue.address1 ? `${venue.address1}<br>` : ''}
${venue.city ? `${venue.city}<br>` : ''}
${venue.postalcode ? `${venue.postalcode}<br>` : ''}
${venue.country ? `${venue.country}<br>` : ''}
<br>
${venue.phone1 ? `${venue.phone1}<br>` : ''}
<br>
${venue.email ? `<b><a href=mailto:${venue.email}>${venue.email}</a></b><br>` : ''}
`;
}

export const VenueFuncs = {
  createVenue,
  createNewVenue,
  isNewVenue,
  getVenueInfo
}